<template>
  <div class="kt-grid kt-grid--ver kt-grid--root">
    <div
      class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v3 kt-login--signin"
      id="kt_login"
    >
      <div
        class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
        :style="getBGStyle()"
      >
        <!--begin::Content-->
        <div class="kt-grid__item kt-grid__item--fluid kt-login__wrapper">
          <router-view></router-view>
        </div>
        <!--end::Content-->
      </div>
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-3.scss";

.kt-login__container {
  padding: 4rem 2rem;
  background-color: #ffffff;
  border-radius: 1rem;
  -webkit-box-shadow: 0px 0px 22px -5px rgba(0, 0, 0, 0.24);
  -moz-box-shadow: 0px 0px 22px -5px rgba(0, 0, 0, 0.24);
  box-shadow: 0px 0px 22px -5px rgba(0, 0, 0, 0.24);
}
</style>

<script>
import { mapState } from "vuex";
import { APP_CONFIG } from "@/common/config";

export default {
  name: "auth",
  computed: {
    ...mapState({
      errors: state => state.auth.errors,
      section: state => state.config.section
    }),
    hasLoginBg() {
      return APP_CONFIG.has_login_bg;
    },
    backgroundImage() {
      const section_bg = APP_CONFIG.login_bgs[this.section];
      const loginBG = section_bg ? section_bg : APP_CONFIG.login_bg;

      // return process.env.BASE_URL + "assets/media/bg/bg-3.jpg";

      return loginBG.startsWith("http")
        ? loginBG
        : process.env.BASE_URL + loginBG;
    }
  },
  methods: {
    getBGStyle() {
      return this.hasLoginBg
        ? {
            backgroundImage: `url(${this.backgroundImage})`,
            backgroundSize: "cover"
          }
        : null;
    }
  }
};
</script>
